import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import _ from 'lodash';

import {
  setVerificationType,
  fetchData,
  saveData,
} from './state/configuration/actions';

import { Filter, Main } from 'Containers';
import VerificationConfigurationForm from './components/VerificationConfigurationForm';
import { VERIFICATION_CONFIGURATION_FORM_NAME } from 'Common/FormEnum';
import TopMessage from './components/TopMessage';
import { errorToast, createToast, toastType } from 'Common/ToastHelper';
import { LoadingPage } from 'Components';
import { getIsDirty } from 'Common/Selectors/DirtySelector';

class VerificationConfigurationContainer extends Component {
  formSubmit = (values) => {
    return this.props.saveData(values);
  };

  componentDidMount() {
    this.props.fetchData();
  }

  componentDidUpdate(prevProps) {
    errorToast(this.props, prevProps, 'fetchError');

    if (!prevProps.submitted && this.props.submitted) {
      createToast(
        toastType.success,
        'Success',
        'Verification Configuration saved successfully',
        true
      );
    }
  }

  disableForm = (verificationStatus) => {
    if (
      !_.isEmpty(verificationStatus) &&
      (verificationStatus.IsSelected || verificationStatus.IsComplete)
    ) {
      return true;
    }

    return false;
  };

  disableErrorProneLimits = (verificationStatus) => {
    if (!_.isEmpty(verificationStatus) && verificationStatus.Phase === 1) {
      return true;
    }

    return false;
  };

  forceFormEnable = (verificationData) => {
    if (
      verificationData.VerificationAsOfDate === null &&
      verificationData.VerificationAsOfDate_Student === null &&
      verificationData.verificationStatus.Phase < 2
    ) {
      return true;
    }

    return false;
  };

  getMainProps = () => {
    const { verificationData, isReadOnly } = this.props;
    const { verificationStatus } = verificationData;
    const disabled =
      (this.disableForm(verificationStatus) ||
        this.disableErrorProneLimits(verificationStatus)) &&
      !this.forceFormEnable(verificationData);
    return {
      toolbox: {
        isReadOnly,
        formName: VERIFICATION_CONFIGURATION_FORM_NAME,
        shown: !disabled,
      },
    };
  };

  render() {
    const { verificationData, fetching } = this.props;
    const { verificationStatus } = verificationData;

    return (
      <Fragment>
        {fetching && <LoadingPage />}
        <Filter title={'Verification Configuration'} />
        <Main {...this.getMainProps()}>
          <TopMessage
            verificationStatus={verificationStatus}
            forceFormEnable={this.forceFormEnable(verificationData)}
          />
          <VerificationConfigurationForm
            onSubmit={this.formSubmit}
            initialValues={verificationData}
            disabled={
              (this.disableForm(verificationStatus) ||
                this.disableErrorProneLimits(verificationStatus)) &&
              !this.forceFormEnable(verificationData)
            }
          />
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { configuration } = state.VerificationConfigurationState;
  ownProps.setPageLevelDirty(getIsDirty()(state));

  return {
    verificationData: configuration.data,
    fetchError: configuration.fetchError,
    fetching: configuration.fetching,
    submitted: configuration.submitted,
    verificationStatus: configuration.verificationStatus,
  };
};

export const VerificationConfiguration = withRouter(
  connect(mapStateToProps, { setVerificationType, fetchData, saveData })(
    VerificationConfigurationContainer
  )
);



// WEBPACK FOOTER //
// ./src/pages/verificationconfiguration/VerificationConfiguration.js